import { Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Iconify from '../Iconify';
import { plainTextFromRichText } from '../../utils/richText';
import OrderMoveButtons from '../listOrder/OrderMoveButtons';

const ArticleFolderListData = ({ articleFolder, columnWidth, handleArticleFolderClick, canReorder = false, disableUp = false, disableDown = false, onMove }) => {

    if (!articleFolder) {
        return (
            <Box className='table_row'>
                <Box sx={{ color: '#EA5E00', minWidth: columnWidth.title, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }} className='machines_listview_table_dataRow'><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.description }} className='machines_listview_table_dataRow'><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
            </Box>
        );
    }

    return (
        <Box className='table_row' onClick={() => handleArticleFolderClick(articleFolder.id)}>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.title, maxWidth: columnWidth.title, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
                <Typography className='tableBodyTypography'>{articleFolder?.title}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.description, maxWidth: columnWidth.description }}>
                <Typography className='tableBodyTypography'>{plainTextFromRichText(articleFolder?.description) || 'N/A'}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '130px', display: 'flex', alignItems: 'center' }}>
                {canReorder && articleFolder && (
                    <OrderMoveButtons
                        disableUp={disableUp}
                        disableDown={disableDown}
                        onMove={(direction) => onMove(articleFolder.id, direction)}
                    />
                )}
                <Iconify icon={'ri:arrow-right-s-line'} />
            </Box>
        </Box>
    );
};

export default ArticleFolderListData;